export const ViewSelector = ({ selectedView, ...sections }) => {
  return sections[selectedView] ? <section>{sections[selectedView]}</section> : null;
};
